import { isEmpty } from 'lodash';
import { useEffect } from 'react';

import {
  CategoryPageFilterApply,
  CategoryPageLoadMore,
  CategoryPageTask,
} from '../../../../telemetry/tasks';

import type { ApolloError } from '@apollo/client';
import type { SelectedOptions } from '@atlassian/mpac-primitives';
import type {
  AppsConnectionFragment,
  GetMarketplaceCategoryQuery,
} from '@atlassian/mpac-services-client';

export const useCategoryTelemetry = ({
  slug,
  initialFetchError,
  category,
  isLoadingMore,
  fetchMoreError,
  appList,
  filters,
  sortKey,
}: {
  slug?: string | null;
  initialFetchError?: ApolloError;
  category: NonNullable<GetMarketplaceCategoryQuery['marketplaceCategory']>['category'] | null;
  isLoadingMore: boolean;
  fetchMoreError?: ApolloError | null;
  appList?: AppsConnectionFragment | null;
  filters: SelectedOptions;
  sortKey: string;
}) => {
  useEffect(() => {
    if (slug) {
      CategoryPageTask.start();
    }
  }, [slug]);

  const isCategoryFetchError = initialFetchError && !category;
  useEffect(() => {
    if (isCategoryFetchError) {
      CategoryPageTask.failed(initialFetchError);
    }
  }, [isCategoryFetchError]);

  useEffect(() => {
    if (category) {
      CategoryPageTask.succeeded();
    }
  }, [!!category]);

  useEffect(() => {
    if (isLoadingMore) {
      CategoryPageLoadMore.start();
    }
  }, [isLoadingMore]);

  useEffect(() => {
    if (fetchMoreError) {
      CategoryPageLoadMore.failed(fetchMoreError);
    }
  }, [fetchMoreError]);

  const areFiltersApplied = !isEmpty(filters);
  useEffect(() => {
    if (sortKey || areFiltersApplied) {
      CategoryPageFilterApply.start();
    }
  }, [sortKey, filters]);

  const isFiltersApplyError = initialFetchError && (areFiltersApplied || sortKey);
  useEffect(() => {
    if (isFiltersApplyError) {
      CategoryPageFilterApply.failed(initialFetchError);
    } else if (appList) {
      CategoryPageLoadMore.succeeded();
      CategoryPageFilterApply.succeeded();
    }
  }, [isFiltersApplyError, appList]);
};
